import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { WorkflowTaskHostComponent } from '../../shared/workflow-surfaces/workflow-task-host.component';
import { WORKFLOW_TASK_OPERATIONS } from '../../shared/workflow-surfaces/workflow-task-operations';
import { OrganizationWorkflowApiService } from './organization-workflow-api.service';

@Component({
  standalone: true,
  selector: 'ain-organization-task-detail',
  imports: [WorkflowTaskHostComponent],
  providers: [{ provide: WORKFLOW_TASK_OPERATIONS, useExisting: OrganizationWorkflowApiService }],
  template: `
    @if (taskId) {
      <ain-workflow-task-host [taskId]="taskId" />
    }
  `
})
export class OrganizationTaskDetailComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);

  taskId = '';

  ngOnInit(): void {
    this.taskId = this.route.snapshot.paramMap.get('id') ?? '';
  }
}
